<script>
import { euroCouponsRequestCouponMethods } from '@state/helpers'
import { required, maxLength, helpers } from 'vuelidate/lib/validators'
import EuroCouponsItemForm from '@components/euro_coupons/item/Form'

const mustBeCool = (value) => {
  let total = value.reduce((total, item) => item['quantity'] + total, 0)
  return total > 0 && total <= 500
} 

export default {
  name: 'EuroCouponsRequestCouponForm',
  components: { EuroCouponsItemForm },
  props: {
    fullform: {
      type: Boolean,
      required: false,
      default: false,
    },
    instanceJson: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    oncomplete: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    oncancel: {
      type: Function,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      modalShow: true,
      loading: true,
      submitting: false,
      action: 'create',
      euroCouponsRequestCouponOptions: [],
      form: {
        url: null,
        // requesting_user: null,
        purchase_order: null,
        items: [
          // {  quantity: 1, unit_value: 1000 },
          // {  quantity: 2, unit_value: 2000 },
          // {  quantity: 3, unit_value: 1000 },
          // {  quantity: 4, unit_value: 1000 },

        ]
      },
      quantity: null,
      value: null,

      //Table
        fields: [        
          { 
            key: 'unit_value', 
            label: this.$t('unit_value'),
            formatter: value => {
              return this.$formatDollar(value)}

          },
          { 
            key: 'quantity', 
            label: this.$t('quantity'), 
            formatter: value => {
              return this.$formatDollar(value)}
          },
            
          { 
            key: 'total', 
            label: 'Subtotal',
            formatter: value => {
              return this.$formatDollar(value)} 

          },
          { 
            key: 'actions', 
            label: this.$t('actions') 
          },
        ],
        items: [],
        
    }
  },
  validations: {
    form: {
      // items: contains(form.items),
      // requesting_user: { required, },
      // quantity: { required, },
      // value: { required, },
      purchase_order: {  },
    },
    items: {
      mustBeCool
    }
  },
  computed: {},

  watch: {
    items(values) {
      this.form.items = values
      this.quantity = values.reduce((a, b) => a + b['quantity'], 0)
      this.value = values.reduce((a, b) => a + (b['quantity'] * b['unit_value']), 0)
    }

  },


  mounted: function () {
    let context = this
    context.form = {
      ...context.form, ...context.instanceJson,
    }
    if (context.instanceJson.url) {
      context.action = 'update'
      context.getObject()
    } else {
      context.action = 'create'
      context.loading = false
    }
  },

  methods: {
    ...euroCouponsRequestCouponMethods,

    formatNumber(value) {
      return Number(value).toLocaleString('es-CO')
    },

    addItem(item) {
      this.items.unshift(item)
    },
    removeItem(index) {
       this.items.splice(index, 1)
    },
    getObject() {
      let context = this
      if (context.action == 'update') {
        const promise = context.fetchEuroCouponsRequestCouponDetail(context.form.url)
        return promise
          .then((data) => {
            context.form = { ...data }
            context.loading = false
          })
          .catch((error) => {
            context.$axios_error_noty(error, context)
            context.loading = false
          })
      }
    },

    submit() {
      let context = this
      context.submitting = true
      context.$v.form.$touch()
      context.$v.items.$touch()
      if (context.$v.form.$invalid || context.$v.items.$invalid) {
        context.submitting = false
        context.$generate_toast(
          context,
          'error',
          context.$t('fill_the_required_fields')
        )
        return
      }
      const promise = context.createUpdateEuroCouponsRequestCoupon(context.form)
      return promise
        .then((data) => {
          context.$generate_toast(
            context,
            'success',
            `${context.$t('request_coupon')} ${
              context.action == 'create' ? context.$t('created') : context.$t('updated')
            } ${context.$t('correctly')}`
          )
          setTimeout(() => {
            context.oncomplete(data.url || null)
            context.submitting = false
          }, 2000)
        })
        .catch((error) => {
          context.submitting = false
          context.$axios_error_noty(error, context)
        })
    },
  },
}
</script>

<template>
  <b-modal
    v-model="modalShow"
    :title="
      action === 'create' ? `${$t('create')} ${$t('request_coupon')}` : `${$t('update')} ${$t('request_coupon')}`
    "
    :size="action === 'create' ? 'md' : 'md'"
    @hidden="oncancel"
    @ok.prevent="submit"
  > 
    <b-container class="p-0">
      <b-row v-if="loading">
        <b-col md="12">
          <div class="text-center">
            <b-spinner
              label="Spinning"
              style="color: #195db2; width: 4rem; height: 4rem"
            ></b-spinner>
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col md="12">
          <!-- 
            Don't touch this generic form, if you need a custom form do 
            a v-else instead and code an alternative form :) 
          -->

          <b-form v-if="fullform" id="form">
            <form-wrapper :validator="$v.form">
                  <b-row>
                    <b-col md="12">
                      <!-- <form-group name="requesting_user" :label="$t(`requesting_user`)" :description="$t(`requesting_user_help_text`)">
                        <b-form-input
                          type="text"
                          v-model="form.requesting_user"
                          slot-scope="{ attrs, listeners }"
                          v-bind="attrs"
                          v-on="listeners"
                        />
                      </form-group> -->
                      <!-- <form-group name="quantity" :label="$t(`quantity`)" :description="$t(`quantity_help_text`)">
                        <b-form-input
                          type="number"
                          v-model="form.quantity"
                          slot-scope="{ attrs, listeners }"
                          v-bind="attrs"
                          v-on="listeners"
                        />
                      </form-group>
                      <form-group name="value" :label="$t(`value`)" :description="$t(`value_help_text`)">
                        <b-form-input
                          type="number"
                          v-model="form.value"
                          slot-scope="{ attrs, listeners }"
                          v-bind="attrs"
                          v-on="listeners"
                        />
                      </form-group> -->
                      <form-group 
                      name="purchase_order"
                      class="text-primary font-weight-bold" 
                      :label="$t(`purchase_order`)" 
                      :description="$t(`purchase_order_help_text`)">
                        <b-form-input
                          type="text"
                          v-model="form.purchase_order"
                          slot-scope="{ attrs, listeners }"
                          v-bind="attrs"
                          v-on="listeners"
                        />
                      </form-group>
                    </b-col>
                  </b-row>
              <div>
                <form-summary />
                
              </div>
            </form-wrapper>
          </b-form>
          <EuroCouponsItemForm
          class="mb-3"
          :add-item="addItem"
          />
          <b-table 
          v-if="items.length"
          hover 
          :items="items" 
          :fields="fields"
          :thead-class="[ 'text-primary', 'border-primary', 'border-bottom-c']">
          
            <template #cell(total)="row">
            {{$formatDollar(row.item.unit_value * row.item.quantity)}}
        
      </template>
      <template #cell(actions)="row">
        <b-button
          :id="`delete-btn-${row.index}`"
          v-b-tooltip.hover="{
            variant: 'danger',
            placement: 'leftbottom',
            title: $t('delete'),
          }"
          variant="btn-link text-danger btn-transparent"
          @click="()=>{ removeItem(row.index)}"
        >
        <i class="far fa-trash-alt"></i>
        </b-button>
        
      </template>
      <template #custom-foot>
        <b-tr>
          <b-td  class="text-primary font-weight-bold text-right" style="border-top: solid 1px"><span >Total</span></b-td>
          <b-td  class="border-primary" style="border-top: solid 1px">{{ quantity }}</b-td>
          <b-td  class="border-primary" style="border-top: solid 1px">{{ value }}</b-td>
        </b-tr>
      </template>

          </b-table>
          <div v-if="!$v.items.mustBeCool" class="alert alert-danger" role="alert">
            La solicitud debe tener  <span class="alert-link"> al menos un bono y máximo 500.</span>
          </div>
          
        </b-col>
      </b-row>
    </b-container>

    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button size="sm" variant="outline-primary"  class="rounded-lg" @click="cancel">
        Cancelar
      </b-button>

      <b-button
        size="sm"
        variant="primary"
        class="rounded-lg"
        :class="{ disabled: submitting }"
        @click="ok"
      >
        <b-spinner v-if="submitting" label="Spinning" small></b-spinner>
        <span v-if="submitting"> {{ $t('saving') }} </span>
        <span v-else>
          <i class="fe-save"></i>
            {{ $t('save') }}
        </span>
      </b-button>

    </template>
  </b-modal>
</template>
<style lang="scss">
  .boder-bottom {
    border: solid 2px;
  }
</style>